// src/components/Sidebar.js
import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { GlobalContext } from '../contexts/GlobalContext';
import './Sidebar.css';

function Sidebar() {
  const { isLoggedIn, userLevel } = useContext(GlobalContext);
  const menuItems = [
    { name: '網站首頁', path: '/' },
    { name: '教會簡介', path: '/about' },
    { name: '聚會時間', path: '/schedule' },
    { name: '查經資料', path: '/bible-study-materials' },
    { name: '牧者的話', path: '/pastor-messages' },
    { name: '講台信息', path: `/sermon-messages` },
    { name: '見證分享', path: '/testimonies' },
    { name: '標竿刊物', path: '/articles' },
    { name: '聯絡我們', path: '/contact' },
    { name: '教會影視', path: '/church-media' },
  ];

  return (
    <nav className="sidebar">
      <ul>
        {isLoggedIn && userLevel == 1 ? (
          <li>
            <NavLink
              to="/admin"
              title="管理主頁"
              className="active"
            >
              管理主頁
            </NavLink>
          </li>
        ) : "" }
        {menuItems.map((item) => (
          <li key={item.name}>
            <NavLink
              to={item.path}
              title={item.name}
              className={({ isActive }) =>
                isActive ? 'active' : undefined
              }
            >
              {item.name}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default Sidebar;
